import { render, staticRenderFns } from "./dadosPessoaisAstec.vue?vue&type=template&id=5626bae4&scoped=true"
import script from "./dadosPessoaisAstec.vue?vue&type=script&lang=js"
export * from "./dadosPessoaisAstec.vue?vue&type=script&lang=js"
import style0 from "./dadosPessoaisAstec.vue?vue&type=style&index=0&id=5626bae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5626bae4",
  null
  
)

export default component.exports